import React from "react";
import { Grid } from "semantic-ui-react";

const styles = {
	mainContainer: {
		backgroundColor: "#fff",
		padding: 10,
		boxShadow: "#1b1c1d3d 1px 2px 2px 1px",
		borderRadius: "4px 4px 4px 4px",
		marginBottom: 20,
	},
	title: {
		color: "#00917d",
		fontWeight: 600,
		textTransform: "uppercase",
		fontSize: "0.9em",
	},
};

const _firstRowStyle = (onEdit) => ({
	padding: 0,
});

const MainWhiteContainer = ({ title, onEdit, children, style, containerStyle }) => {
	return (
		<Grid style={{ margin: 0, ...style }}>
			<Grid.Row style={_firstRowStyle(onEdit)}>
				<Grid.Column
					mobile={16}
					tablet={16}
					computer={16}
					style={{ display: "flex", alignItems: "flex-end", paddingBottom: 3, paddingLeft: "1.5em" }}
				>
					<span style={styles.title}>{title}</span>
				</Grid.Column>
			</Grid.Row>

			<Grid.Row style={{ ...styles.mainContainer, ...containerStyle }}>{children}</Grid.Row>
		</Grid>
	);
};

export default MainWhiteContainer;
